"use client";

import React from "react";

import { cn } from "utils/src/cn";
import { useSnapshot } from "valtio";
import log from "logbeacon";
import { QuickInsightsSearchModalCreateAble } from "../modal";
import { chatTypeMap, sourceMap } from "../TokenDetails/ASKList";
import { CategoryType } from "../QuickInsights/constants";
import { HomeQuestionCardProps } from "./types";
import { QuickInsightsContent } from "./QuickInsightsContent";
import { encodeString } from "@/src/utils/stringEncoder";
import { rootStore } from "@/src/store";
import { useRecommendQuestion, useRedirectChat } from "@/src/hooks";

export const IconMap = ["edgen-Sources", "stats", "candles", "cart-add"];
/**
 * HomeQuestionCard component displays the main search card on the home page
 * with questions, categories, and feature cards.
 */
export const HomeQuestionCard: React.FC<HomeQuestionCardProps> = ({
  className,
}) => {
  const { type } = useSnapshot(rootStore.home);
  const queryParams = {
    [`scopes[${chatTypeMap[type]}]`]: 20,
  };
  const { questions, isLoading } = useRecommendQuestion(queryParams, {
    enabled: true,
    staleTime: 1000 * 60 * 5,
    key: chatTypeMap[type],
  });
  const { handleCheckChatVaild } = useRedirectChat();

  const onCardClick = async (title: string) => {
    const card = questions?.find((card) => card.title === title);
    if (!card) {
      return;
    }
    const hasPlaceholder = card?.prompt?.includes("{");
    if (!hasPlaceholder) {
      handleCheckChatVaild({
        question: card.prompt_translation,
        cacheQuestion: card.prompt,
        sign: "general",
        senderContext: true,
      });
      return;
    }
    // const isBlueChip = BLUECHIP_QUESTION_LIST.includes(title);
    const res = await QuickInsightsSearchModalCreateAble({
      title,

      type: type === "stock" ? "us-stocks" : "crypto",
      sort: "TURNOVER_RATE",
      modalProps: {
        showClose: true,
      },
    });
    if (!res) {
      return;
    }
    log.debug("[文案]HomeQuestionCard res:", res, type);
    const replaceStr = type === "stock" ? "{ticker}" : "{token}";
    log.debug("[文案]HomeQuestionCard replaceStr:", replaceStr, card);
    const { keyword, token, category } = res;
    const prompt = card?.prompt?.replace(replaceStr, token);
    const prompt_translation = card?.prompt_translation?.replace(
      replaceStr,
      token,
    );
    const source = sourceMap[card?.key || ""] || "chat";
    log.debug("[文案]HomeQuestionCard prompt:", prompt, prompt_translation);
    const signPrefix = category === CategoryType.STOCKS ? "stock_" : "token_";
    log.debug("[文案]HomeQuestionCard signPrefix:", signPrefix);
    handleCheckChatVaild({
      question: prompt_translation,
      cacheQuestion: prompt,
      sign: `${signPrefix}${encodeString(`${source}:${keyword.replace(/\+id#$/g, "")}`)}`,
      senderContext: true,
    });
    return;
  };
  return (
    <div className={cn(className)}>
      {/* Categories & Features Section */}
      {(isLoading || (questions?.length && questions?.length > 0)) && (
        <QuickInsightsContent
          featureCards={questions || []}
          onCardClick={onCardClick}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
